import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutlayout_dimuxref2 extends Layout {
    sourceDimuidents: DataSource;
    sourceDimuxref2: DataSource;
    sourceDimuxref: DataSource;
    sourceDiuser: DataSource;
    textboxDimuiDesc2: Textbox;
    textboxDimuiDesc: Textbox;
    textboxDimuiIdent: Textbox;
    textboxDimuxIdent2: Textbox;
    textboxDimuxIdent: Textbox;
    textboxDimuxLogin2: Textbox;
    textboxDimuxLogin: Textbox;
    textboxDimuxValue: Textbox;
}
